import React from "react";
import styles from "./style.module.scss";

const ShadowBox: React.FC = props => {
  const { children } = props;
  return <div className={styles.shadowBox}>{children}</div>;
};

export default ShadowBox;
